// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f32c2def","453":"5833ad7d","667":"e0e59814"}[chunkId] + ".chunk.js";
};